import React from 'react';
import { type RouteObject } from 'react-router-dom';

import { OWNERS_HUB_ROUTES } from '@/constants/routes';

import VerifyEmail from './index';

/**
 * `/verify-email?code=<uuid>` — email-verification landing for the Telegram signup flow. Standalone,
 * full-bleed, NOT auth-gated (the link may be opened on a device where the owner is not signed in).
 */
export const verifyEmailRoute: RouteObject = {
  path: OWNERS_HUB_ROUTES.VERIFY_EMAIL,
  element: <VerifyEmail />,
};

export default verifyEmailRoute;
